function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "eAGM SPOT",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pqfg1a0o0a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2460",
    style: {
      fill: "#838383"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2175",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4554"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4553",
    style: {
      clipPath: "url(#pqfg1a0o0a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1001",
    d: "M10.437 0h.812c.17.027.339.05.508.081a5.079 5.079 0 0 1 2.712 1.407 4.925 4.925 0 0 1 1.35 2.332c.077.306.121.62.18.93v.812c-.042.245-.073.492-.13.733a5 5 0 0 1-2.309 3.236 4.958 4.958 0 0 1-4.108.533.237.237 0 0 0-.271.068c-.331.338-.676.663-1.009 1a.633.633 0 0 1-.511.213c-.248-.012-.5 0-.738 0a.314.314 0 0 0-.016.046c0 .24-.017.481 0 .718a.51.51 0 0 1-.656.565c-.186-.037-.378-.043-.56-.063-.015.026-.024.034-.025.044-.025.248-.054.5-.073.744-.035.47-.175.6-.649.634-.253.017-.505.049-.772.075l.062.553c.02.179.055.348-.075.477-.295.3-.606.577-.911.864H.343A.675.675 0 0 1 0 15.656V12.75c.167-.19.324-.39.5-.568Q3.165 9.51 5.836 6.848a.23.23 0 0 0 .064-.256 7.131 7.131 0 0 1-.176-.853A4.991 4.991 0 0 1 6.315 2.7 5.025 5.025 0 0 1 9.506.183c.305-.083.62-.123.931-.183m3.131 3.821a1.4 1.4 0 1 0-1.39 1.4 1.39 1.39 0 0 0 1.39-1.4",
    style: {
      fill: "#838383"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.c0d464a2.svg";
export { ForwardRef as ReactComponent };